// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapperStatistics {\n  font-size: 24px;\n  line-height: 32px;\n  color: #1a1d24;\n}\n.titleStatistics {\n  margin-left: 20px;\n  margin-top: 30px;\n  margin-bottom: -20px;\n}", ""]);
// Exports
module.exports = exports;
